import axios from "axios";


export class Http_service {

    static SESSION_STORAGE_KEY = "accessToken";

    constructor(
    )
    {}

    // sendEmail(body) {
    //     // console.log("body at http.post",body);
    //     const header = {
    //         headers: new Headers()
    //           .set('Content-Type',  'application/json')
    //     }

    //     // return this.http.post('http://localhost:5001/causalfunnel-21/us-central1/CausalFunnelEmailSend',JSON.stringify(body),header)
    //     return this.http.post('https://us-central1-causalfunnel-21.cloudfunctions.net/CausalFunnelEmailSend',JSON.stringify(body),header)
    //}

    // getFB_AdData(URL) {
    //     // console.log("URL in http.get",URL);
    //     const header = {
    //         headers: new HttpHeaders()
    //           .set('Content-Type',  'application/json')
    //     }
    //     return this.http.get(URL ,header)
    // }

    // Send_Customer_Email(url, body) {
    //     console.log("body at http.post",body);
    //     const header = {
    //         headers: new HttpHeaders()
    //           .set('Content-Type',  'application/json')
    //           .set("Access-Control-Allow-Origin", "*")
    //     }
    //     // console.log("hitting this url for sending emails",url)
    //     return this.http.post(url, JSON.stringify(body), header)
    // }


    Check_Sent_Email_Status(url) {
        const options = {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'api-key': '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'
          }
        };
        
        return axios.get(url, options)
      }
}